import React from "react";
import useByggherreAccess from "@/hooks/useByggherreAccess";
import { Network } from "lucide-react";
import SectionDocumentEditor from "./SectionDocumentEditor";
import {
  DELEGATION_ORDER_SECTIONS,
  BYGGHERRE_STATUS_LABELS,
} from "@/lib/basProcess/byggherreDocs";
import { generateDelegationOrderWordDocument } from "@/lib/documentGenerator/byggherreWordGenerators";

export const DelegationOrder: React.FC<{ projectId: string }> = ({ projectId }) => {
  const { canManage } = useByggherreAccess(projectId);
  return (
  <SectionDocumentEditor
    projectId={projectId}
    table="delegation_orders"
    docNumber="51"
    documentType="delegeringsordning"
    title="Delegeringsordning byggherre"
    description="Visar kedjan från styrelse och VD ned till byggherrens representant: vem som får fördela vidare, vilka befogenheter som följer med och vem som är ställföreträdare."
    legalRef="AML 3 kap. 6 § · AFS 2023:3 2 kap. 15 §"
    icon={Network}
    sections={DELEGATION_ORDER_SECTIONS}
    statusLabels={BYGGHERRE_STATUS_LABELS}
    defaultName="Delegeringsordning byggherre"
    onExport={(doc, projectName) => generateDelegationOrderWordDocument(doc, projectName)}
    emptyText="Ingen delegeringsordning upprättad ännu. Skapa den med förifylld standardtext och anpassa efter er organisation."
  readOnly={!canManage}
    auditDocumentType="delegeringsordning"
  />
  );
};

export default DelegationOrder;
